import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import { useDrawerOpen } from './PullToRefresh/PullToRefreshContext'
import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import Typography from '@material-ui/core/Typography'
import { useSelector } from 'react-redux'

const DEFAULT_DRAWER_Z_INDEX = 1000

export default function CustomDrawer({
  open,
  onClose,
  title,
  children,
  customStyles,
  paperWidth,
  className = "custom-drawer",
  disableEnforceFocus = false,
  hideHeader = false,
  variant: variantProp,
  zIndex,
}) {
  const handleClose = () => onClose()
  const isMobile = useSelector(state => state.common.isMobile)
  const variant = variantProp ?? (isMobile ? 'persistent' : 'temporary')

  useDrawerOpen(open)

  const useStyles = makeStyles(() => (
    isMobile ? {
      paper: {
        'width': '100%',
        'top': 'calc(env(safe-area-inset-top) * 2)',
        'height': 'calc(100% - (env(safe-area-inset-top) * 2))',
        'box-shadow': '0px 0px 6px #0000001a',
        'overflow': 'hidden',
      }}
      : {
        paper: {width: paperWidth || '40%'}
      })
    )

  const classes = useStyles()
  const paperStyles = customStyles?.paper && typeof customStyles.paper === 'object'
    ? customStyles.paper
    : null

  return (
    <Drawer
      disableEnforceFocus={disableEnforceFocus}
      classes={{
        paper: !paperStyles ? (customStyles?.paper || classes.paper) : '',
        root: customStyles?.root || ''
      }}
      PaperProps={paperStyles ? { style: paperStyles } : undefined}
      anchor="right"
      open={open}
      onClose={handleClose}
      style={{ zIndex: zIndex ?? DEFAULT_DRAWER_Z_INDEX }}
      hideBackdrop={isMobile}
      ModalProps={{
        disableBackdropClick: isMobile,
        style: isMobile && paperStyles?.top ? { top: paperStyles.top } : {}
      }}
      variant={variant}
    >
      <div className={className}>
        { 
          // Si hideHeader es false se renderiza el header original con sus clases y padding originales (pl-4, pr-4, pt-3, pb-3)
          !hideHeader && (
            <div className="custom-drawer-header d-flex">
              <IconButton
                className="arrow-back-btn"
                onClick={handleClose}
                aria-expanded={open}
                aria-label="show more"
              >
                <ChevronLeftIcon fontSize="small" />
              </IconButton>

              <Typography className="text-header-drawer" component="p">
                {title}
              </Typography>
            </div>
          )
        }
        {children}
      </div>
    </Drawer>
  )
}
